var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6999_5260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 1.33325H3.33333C2.59333 1.33325 2 1.93325 2 2.66659V11.9999C2 12.7333 2.6 13.3333 3.33333 13.3333H6L7.52667 14.8599C7.78667 15.1199 8.20667 15.1199 8.46667 14.8599L10 13.3333H12.6667C13.4 13.3333 14 12.7333 14 11.9999V2.66659C14 1.93325 13.4 1.33325 12.6667 1.33325ZM8 3.53325C8.99333 3.53325 9.8 4.33992 9.8 5.33325C9.8 6.32659 8.99333 7.13325 8 7.13325C7.00667 7.13325 6.2 6.32659 6.2 5.33325C6.2 4.33992 7.00667 3.53325 8 3.53325ZM12 10.6666H4V10.0666C4 8.73325 6.66667 7.99992 8 7.99992C9.33333 7.99992 12 8.73325 12 10.0666V10.6666Z",
    fill: "#C1CACE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6999_5260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonPin);
export default __webpack_public_path__ + "static/media/person_pin.fc221ddaaa2df64df74185786c8763f2.svg";
export { ForwardRef as ReactComponent };